export { helpEditTopicsResource, hiddenSectionWarningResource } from './resources';
